import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  HostBinding,
  OnDestroy,
  Output,
  QueryList,
} from '@angular/core';
import { Subject, Subscription, filter, merge, takeUntil } from 'rxjs';
import {
  ListItemSelectionChangeSource,
  ModusListItem,
} from '../list-item/modus-list-item.component';

/* eslint-disable @angular-eslint/component-class-suffix */

@Component({
  selector: 'md-list',
  exportAs: 'modusList',
  templateUrl: './modus-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModusList implements AfterContentInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();
  private _subscription = new Subscription();

  @ContentChildren(ModusListItem, { descendants: true }) items!: QueryList<ModusListItem>;
  @Output() readonly selectionChange = new EventEmitter<ModusListItem>();

  @HostBinding('class') componentClasses = 'modus-list';

  ngAfterContentInit(): void {
    this.subscribeToSelectionChanges();

    this.items.changes.subscribe(() => {
      this.subscribeToSelectionChanges();
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._subscription.unsubscribe();
  }

  clearSelection() {
    this.items.forEach((item) => item.deselect());
  }

  private subscribeToSelectionChanges() {
    this._subscription.unsubscribe();

    this._subscription = merge(...this.items.map((item) => item.selectionChange))
      .pipe(
        filter((change) => change.source === ListItemSelectionChangeSource.userInput),
        takeUntil(this._destroy$),
      )
      .subscribe(({ item: selected }) => {
        const other = this.items.filter((item) => {
          return item !== selected;
        });
        other.forEach((item) => item.deselect());

        this.selectionChange.emit(selected);
      });
  }
}
